<template>
  <div class="app-content">
    <el-tabs v-model="activeKey" type="card">
      <el-tab-pane name="IOS">
        <span slot="label">
          <i class="iconfont icon-ios"></i>
          I O S
        </span>
        <el-row :gutter="20">
          <el-col v-for="(item,index) in ios" :key="index" :xs="4" :sm="4" :md="8" :lg="8" :xl="8" :xxl="12">
            <el-card shadow="hover" :title="item.appName" class="list-card confont-style">
              <div slot="header" class="clearfix">
                <span>{{item.appName}}</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="handleUpdate(item, 'ios')">更新</el-button>
              </div>
              <p class="item-line confont-style">
                <span class="item-line-label ">APP 描述：</span>
                <span class="item-line-value">{{item.desc}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">版本号：</span>
                <span class="item-line-value version-style">{{item.version}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">版本描述：</span>
                <span class="item-line-value">{{item.versionDesc}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">短版本号：</span>
                <span class="item-line-value">{{item.shortVersion}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">下载地址：</span>
                <span class="item-line-value">{{item.downloadPath}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">是否强制更新：</span>
                <span :class="['item-line-value',item.forceUpdate?'isForce':'' ]">{{item.forceUpdate?'是':'否'}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">最低兼容版本：</span>
                <span class="item-line-value">{{item.minSupportVersion}}</span>
              </p>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane name="Android">
        <span slot="label">
          <i class="iconfont icon-anzhuo-"></i>
          Android
        </span>
        <el-row :gutter="20">
          <el-col v-for="(item,index) in android" :key="index" :xs="4" :sm="4" :md="8" :lg="8" :xl="8" :xxl="12">
            <el-card shadow="hover" :title="item.appName" class="list-card confont-style">
              <div slot="header" class="clearfix">
                <span>{{item.appName}}</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="handleUpdate(item, 'android')">更新</el-button>
              </div>
              <p class="item-line confont-style">
                <span class="item-line-label">APP 描述：</span>
                <span class="item-line-value">{{item.desc}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">版本号：</span>
                <span class="item-line-value version-style">{{item.version}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">版本描述：</span>
                <span class="item-line-value">{{item.versionDesc}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">短版本号：</span>
                <span class="item-line-value">{{item.shortVersion}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">下载地址：</span>
                <span class="item-line-value">{{item.downloadPath}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">是否强制更新：</span>
                <span :class="['item-line-value',item.forceUpdate?'isForce':'' ]">{{item.forceUpdate?'是':'否'}}</span>
              </p>
              <p class="item-line confont-style">
                <span class="item-line-label">最低兼容版本：</span>
                <span class="item-line-value">{{item.minSupportVersion}}</span>
              </p>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :close-on-click-modal="false" width="50%" :visible.sync="visible" :title="modelTitle" :before-close="handleCancel">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="APP ID" prop="appId">
          <el-input v-model="form.appId" placeholder="请输入APP ID" :disabled="isUpdate" />
        </el-form-item>
        <el-form-item label="平台" prop="platform">
          <el-select v-model="form.platform" style="width: 100%" :disabled="isUpdate" placeholder="请选择平台">
            <el-option value="android">android</el-option>
            <el-option value="ios">ios</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="APP名称" prop="appName">
          <el-input v-model="form.appName" placeholder="请输入APP名称" />
        </el-form-item>
        <el-form-item label="APP描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请输入APP描述" />
        </el-form-item>
        <el-form-item v-if="isUpdate" label="版本号" prop="version">
          <el-input v-model="form.version" placeholder="请输入版本号" />
        </el-form-item>
        <el-form-item v-if="isUpdate" label="短版本号" prop="shortVersion">
          <el-input v-model="form.shortVersion" placeholder="请输入短版本号" />
        </el-form-item>
        <el-form-item v-if="isUpdate" label="版本描述" prop="versionDesc">
          <el-input v-model="form.versionDesc" placeholder="请输入版本描述" />
        </el-form-item>
        <el-form-item v-if="isUpdate" label="下载地址" prop="downloadPath">
          <el-input v-model="form.downloadPath" placeholder="请输入下载地址" />
        </el-form-item>
        <el-form-item v-if="isUpdate" label="强制更新" prop="forceUpdate">
          <el-radio-group v-model="form.forceUpdate">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="isUpdate" label="最低兼容版本" prop="minSupportVersion">
          <el-input v-model="form.minSupportVersion" placeholder="请输入最低兼容版本" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleOk">确 定</el-button>
      </span>
    </el-dialog>
    <div class="file-upload-footer">
      <el-button type="primary" @click="handleAdd">新增</el-button>
    </div>
  </div>
</template>

<script>
import { xpsApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading'
const defaultAppForm = {
  appId: '',
  platform: '',
  appName: '',
  desc: '',
  version: '',
  shortVersion: '',
  versionDesc: '',
  downloadPath: '',
  forceUpdate: true,
  minSupportVersion: ''
}
export default {
  name: 'home',
  data () {
    return {
      activeKey: 'IOS',
      visible: false,
      modelTitle: '',
      form: JSON.parse(JSON.stringify(defaultAppForm)),
      android: [],
      ios: [],
      isUpdate: false,
      rules: {
        appId: [{ required: true, message: '请输入 App Id' }],
        platform: [{ required: true, message: '请选择 APP 平台' }],
        appName: [{ required: true, message: '请输入 APP 名称' }],
        desc: [{ required: true, message: '请输入 APP 描述' }]
      }
    }
  },
  mounted () {
    this.getAppList();
  },
  methods: {
    async getAppList () {
      showLoading()
      const res = await xpsApi.getAppList();
      this.android = res.android;
      this.ios = res.ios;
      hideLoading()
    },
    handleAdd () {
      this.visible = true;
      this.modelTitle = `版本新增`;
    },
    // 取消事件
    handleCancel () {
      this.visible = false;
      this.form = JSON.parse(JSON.stringify(defaultAppForm))
      this.$refs['form'].resetFields();
      this.isUpdate = false;
    },
    // 确定事件
    handleOk () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          if (this.isUpdate) {
            this.updateApp(this.form);
          } else {
            this.addApp(this.form);
          }
        }
      });
    },
    // 编辑
    handleUpdate (item, type) {
      this.visible = true;
      this.modelTitle = `版本更新`;
      this.isUpdate = true;
      this.$nextTick(() => {
        this.form = (Object.assign({ platform: type }, item));
      });
    },
    // 新增
    addApp (values) {
      xpsApi.addNewApp(values)
        .then((res) => {
          this.$message.success(res);
          this.$refs['form'].resetFields();
          this.visible = false;
          this.getAppList();
        })
        .catch((err) => {
          this.$message.error(err.desc);
        })
    },
    // 更新
    updateApp (values) {
      xpsApi.updateApp(values)
        .then((res) => {
          this.$message.success(res);
          this.$refs['form'].resetFields();
          this.visible = false;
          this.isUpdate = false;
          this.getAppList();
        })
        .catch((err) => {
          this.$message.error(err.desc);
        })
    }
  }
}
</script>
<style>
.app-content {
  padding: 24px;
}
.list-card {
  border-radius: 6px !important;
}

.list-card .ant-card-head-title {
  padding: 5px 16px !important;
}

.item-line {
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 5px 0;
}

.item-line:hover {
  background: #f1f1f1;
}

.item-line-label {
  width: 30%;
  text-align: right;
}

.item-line-value {
  max-width: 65%;
  padding-right: 5px;
  word-wrap: break-word;
}
.file-upload-footer {
  position: fixed;
  width: 100%;
  margin-left: -24px;
  padding: 10px 10px 10px 24px;
  bottom: 0;
  background-color: #fff;
  border-top: 1px solid #efefef;
}

.version-style {
  color: blue;
}

.isForce {
  color: red;
}
</style>
